import {Button, Form, Modal} from 'antd';
import Password from 'antd/es/input/Password';
import {useState} from 'react';

import {usePostAdminChangePasswordMutation} from '../../../../gen/api/apis';
import {useNotification} from '../../../../NotificationContext';

export const ChangePasswordDialog = () => {
    const notify = useNotification();
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const changePasswordQuery = usePostAdminChangePasswordMutation({
        onSuccess: () => {
            console.log('Password changed');
            form.resetFields();
            notify.openNotificationWithIcon('success', 'Password changed');
            setVisible(false);
        },
    });

    const submit = () => {
        form.validateFields().then((values) => {
            changePasswordQuery.mutate({
                params: {
                    oldPassword: values.oldPassword,
                    newPassword: values.newPassword,
                },
            });
            console.log(values);
        });
    };
    return (
        <div>
            <Button
                type="default"
                onClick={() => setVisible(true)}
            >
                Change Password
            </Button>
            <Modal
                open={visible}
                onCancel={() => setVisible(false)}
                onOk={submit}
                title="Change Password"
            >
                <Form
                    layout="horizontal"
                    labelCol={{span: 7}}
                    wrapperCol={{span: 17}}
                    preserve={false}
                    form={form}
                    onFinish={(values) => {
                        console.log(values);
                    }}
                >
                    <Form.Item
                        name="oldPassword"
                        label="Old Password"
                        rules={[{required: true, message: 'Please input your old password!'}]}
                    >
                        <Password />
                    </Form.Item>
                    <Form.Item
                        name="newPassword"
                        label="New Password"
                        rules={[{required: true, message: 'Please input your new password!'}]}
                    >
                        <Password />
                    </Form.Item>
                    <Form.Item
                        name="confirmPassword"
                        label="Confirm Password"
                        rules={[{required: true, message: 'Please confirm your password!'}]}
                    >
                        <Password />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
